export type SpeakerLabelOverride = {
  from: string;
  to: string;
};

export function buildSpeakerLabelOverrides(
  originalLabels: string[],
  editedLabels: Record<string, string>,
  editEnabled: boolean,
): SpeakerLabelOverride[] | undefined {
  if (!editEnabled) {
    return undefined;
  }

  const overrides = originalLabels
    .map((from) => ({ from, to: (editedLabels[from] ?? from).trim() }))
    .filter(({ from, to }) => from !== to && to.length > 0);

  return overrides.length > 0 ? overrides : undefined;
}
